import { render, staticRenderFns } from "./TitlesListingMenu.vue?vue&type=template&id=60776348&"
import script from "./TitlesListingMenu.vue?vue&type=script&lang=js&"
export * from "./TitlesListingMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports